import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  formControl: {
    width: '16rem',
    maxWidth: '16rem',
    overflow: 'hidden',
    flexDirection: 'row',
    display: 'inline-flex',
    justifyContent: 'space-between',
  },
  select: {
    fontSize: 'medium',
    fontWeight: 'bold',
    width: '100%',
    '& .MuiSelect-select': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
});
